"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toStateSummary = toStateSummary;
const derived_1 = require("./derived");
function threadSummary(thread) {
    const activePlan = thread.plans.find(p => p.status === 'implementing') ?? null;
    const pendingStepCount = activePlan
        ? activePlan.steps.filter(s => s.status !== 'done' && s.status !== 'cancelled').length
        : 0;
    return {
        id: thread.id,
        title: thread.manifest?.title ?? thread.idea?.title ?? thread.id,
        status: (0, derived_1.getThreadStatus)(thread).toLowerCase(),
        priority: thread.manifest?.priority ?? derived_1.DEFAULT_ROADMAP_PRIORITY,
        activePlanId: activePlan?.id ?? null,
        pendingStepCount,
        stale: (thread.stale?.length ?? 0) > 0,
    };
}
function weaveSummary(weave) {
    return {
        id: weave.id,
        status: (0, derived_1.getWeaveStatus)(weave),
        threads: weave.threads.map(threadSummary),
    };
}
/**
 * Project a full LoomState into the lightweight session-start map. Pure — it
 * neither mutates `state` nor re-walks the filesystem. Carries forward whatever
 * weave filtering the caller already applied (the projection is over
 * `state.weaves` as given).
 */
function toStateSummary(state) {
    return {
        mode: state.mode,
        loomName: state.loomName,
        generatedAt: state.generatedAt,
        summary: {
            totalWeaves: state.summary.totalWeaves,
            totalPlans: state.summary.totalPlans,
            stalePlans: state.summary.stalePlans,
            blockedSteps: state.summary.blockedSteps,
        },
        weaves: state.weaves.map(weaveSummary),
    };
}
